/**
 * Live video from assigned kit, as a map thumbnail.
 *
 * Sentinel is the ask surface, not a player. The feed sits on the map small
 * until the operator enlarges it (the player already has that control).
 */
import React from 'react';
import { Box } from '@mui/material';
import LiveStreamPlayer from '@signals/cop-ui/components/LiveStreamPlayer';
import { MissionDeviceTrack } from './useMissionDeviceTracks';

export interface MissionVideoStripProps {
  tracks: MissionDeviceTrack[];
  /** Fly the mission map to the device carrying the camera. */
  onLocate?: (longitude: number, latitude: number) => void;
}

const MissionVideoStrip: React.FC<MissionVideoStripProps> = ({ tracks, onLocate }) => {
  const streaming = tracks.filter((t) => t.isStreaming);
  if (streaming.length === 0) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        left: 16,
        bottom: 88,
        zIndex: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.75,
        width: 168,
        pointerEvents: 'none',
        '& > *': { pointerEvents: 'auto' },
      }}
    >
      {streaming.map((track) => (
        <LiveStreamPlayer
          key={track.deviceId}
          deviceId={track.streamDeviceId || track.deviceId}
          variant="pip"
          label={track.label}
          onLocate={onLocate ? () => onLocate(track.longitude, track.latitude) : undefined}
        />
      ))}
    </Box>
  );
};

export default MissionVideoStrip;
